import { render } from "./SpeakerDetailDialog.vue?vue&type=template&id=118658fc&scoped=true&ts=true"
import script from "./SpeakerDetailDialog.vue?vue&type=script&lang=ts"
export * from "./SpeakerDetailDialog.vue?vue&type=script&lang=ts"

import "./SpeakerDetailDialog.vue?vue&type=style&index=0&id=118658fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118658fc"]])

export default __exports__